import { landing as en_landing } from "../en/landing";

/** landing — ru slice. */
export const landing: Record<keyof typeof en_landing, string> = {
  // ---- Meta / SEO ----
  landing_meta_home_title: "Linqx — Без пустых разговоров",
  landing_meta_home_description:
    "Находи людей на одной волне, изучай город вместе и превращай незнакомцев в истории.",
  landing_meta_root_description:
    "Меньше свайпов, больше жизни. Находи людей на одной волне, изучай город вместе и создавай настоящие связи через общие впечатления.",
  landing_meta_privacy_title: "Linqx — Политика конфиденциальности",
  landing_meta_privacy_description:
    "Узнай, как Linqx собирает, использует и защищает твои персональные данные.",
  landing_meta_terms_title: "Linqx — Условия использования",
  landing_meta_terms_description:
    "Прочитай условия использования платформы и сервисов Linqx.",
  landing_meta_eula_title: "Linqx — Лицензионное соглашение (EULA)",
  landing_meta_eula_description:
    "Прочитай лицензионное соглашение с конечным пользователем (EULA) мобильного приложения Linqx.",

  // ---- Header / nav ----
  landing_nav_features: "Возможности",
  landing_nav_about: "О нас",
  landing_nav_join_waitlist: "В список ожидания",
  landing_nav_toggle_menu: "Открыть меню",

  // ---- Hero ----
  landing_hero_eyebrow: "Меньше свайпов. Больше жизни.",
  landing_hero_title: "без пустых разговоров.",
  landing_hero_meet_prefix: "Знакомься с теми, кто любит",
  landing_hero_rotating_adventure: "приключения",
  landing_hero_rotating_nightlife: "ночную жизнь",
  landing_hero_rotating_coffee: "свидания за кофе",
  landing_hero_rotating_events: "живые события",
  landing_hero_rotating_experiences: "новые впечатления",
  landing_hero_subtitle:
    "Знакомься, делись впечатлениями в своём городе и создавай настоящую связь с кем-то.",
  landing_hero_subtitle_emphasis: "Всё просто.",
  landing_hero_cta_match: "Мэтч",
  landing_hero_cta_create_profile: "Создать профиль",
  landing_hero_hint_mobile: "Свайпай карточки 👇 ",
  landing_hero_hint_desktop: "Попробуй колоду — потяни карточку 👉 ",
  landing_hero_hint_confirm:
    "Понравился человек? Подтверди после встречи вживую.",
  landing_hero_scroll_indicator: "Листай, чтобы узнать больше",

  // ---- Swipe deck (a11y) ----
  landing_deck_pass_label: "Пропустить",
  landing_deck_link_label: "Связаться",
  landing_deck_stamp_link: "LINK",
  landing_deck_stamp_nope: "NOPE",

  // ---- Marquee band ----
  landing_marquee_no_small_talk: "Без пустых разговоров",
  landing_marquee_real_connections: "Настоящие связи",
  landing_marquee_meet_irl: "Встречи вживую",
  landing_marquee_share_the_night: "Разделите вечер",
  landing_marquee_adventure: "Приключения",
  landing_marquee_nightlife: "Ночная жизнь",
  landing_marquee_coffee_dates: "Свидания за кофе",
  landing_marquee_live_music: "Живая музыка",
  landing_marquee_city_explorers: "Исследователи города",

  // ---- Features section ----
  landing_features_title_prefix: "Найди свою ",
  landing_features_title_highlight: "волну",
  landing_features_subtitle: "Выбирай впечатления под свою энергию.",
  landing_features_vibe_adventure: "Приключения",
  landing_features_vibe_lowkey: "Спокойно",
  landing_features_vibe_outdoor: "На улице",
  landing_features_vibe_indoor: "Дома",
  landing_features_vibe_events: "События",
  landing_features_vibe_nightlife: "Ночная жизнь",
  landing_features_vibe_foodie: "Фуди",
  landing_features_vibe_coffee: "Кофе",
  landing_features_vibe_art: "Искусство",
  landing_features_vibe_music: "Музыка",
  landing_features_vibe_sports: "Спорт",
  landing_features_vibe_travel: "Путешествия",
  landing_features_card_match_title: "Настоящие мэтчи",
  landing_features_card_match_desc:
    "Никаких алгоритмов и игр. Только настоящие связи на основе общих интересов и впечатлений.",
  landing_features_card_experience_title: "Впечатления вместе",
  landing_features_card_experience_desc:
    "Планируй досуг, изучай город и создавай воспоминания с кем-то новым.",
  landing_features_card_build_title: "Настоящие связи",
  landing_features_card_build_desc:
    "Выйди за рамки пустых разговоров и строй отношения, которые остаются надолго.",

  // ---- Flow showcase (how it works) ----
  landing_flow_badge: "Как это работает",
  landing_flow_title_prefix: "От «привет» до встречи — ",
  landing_flow_title_highlight: "в один поток",
  landing_flow_subtitle:
    "Пройди путь Linqx — каждый тап, свайп и искру, так, как это происходит на самом деле.",
  landing_flow_keep_scrolling: "Листай дальше",

  landing_flow_discover_eyebrow: "01 — Открой",
  landing_flow_discover_title: "Найди своих людей",
  landing_flow_discover_desc:
    "Задай свою волну и смотри, кто реально рядом. Настоящие люди рядом с тобой, с теми же увлечениями.",
  landing_flow_discover_action_vibe: "Выбери свою волну",
  landing_flow_discover_action_nearby: "Смотри, кто рядом",
  landing_flow_discover_action_profile: "Твой профиль готов",

  landing_flow_connect_eyebrow: "02 — Свяжись",
  landing_flow_connect_title: "Встреча, потом мэтч",
  landing_flow_connect_desc:
    "Свайп сразу к реальному плану. Сначала встреча вживую — а мэтч только когда искра настоящая.",
  landing_flow_connect_action_swipe: "Свайпни, чтобы связаться",
  landing_flow_connect_action_meet: "Выбери место встречи",
  landing_flow_connect_action_match: "Это Linq!",
  landing_flow_connect_action_chat: "Обменяйтесь контактами и общайтесь",

  landing_flow_live_eyebrow: "03 — Живи",
  landing_flow_live_title: "Проживи вечер",
  landing_flow_live_desc:
    "Преврати мэтч в вечеринку — события рядом, чек-ины и немного дружеского соревнования.",
  landing_flow_live_action_events: "Открывай события",
  landing_flow_live_action_checkin: "Чек-ин и очки",
  landing_flow_live_action_leaderboard: "Возглавь рейтинг",

  // ---- Flow phone screens (in-app demo) ----
  landing_screen_vibes_title: "Твоя волна",
  landing_screen_vibes_subtitle: "Что тебе нравится?",
  landing_screen_vibes_continue: "Продолжить",
  landing_screen_vibe_adventure: "Приключения",
  landing_screen_vibe_nightlife: "Ночная жизнь",
  landing_screen_vibe_coffee: "Кофе",
  landing_screen_vibe_live_music: "Живая музыка",
  landing_screen_vibe_art: "Искусство",
  landing_screen_vibe_foodie: "Фуди",

  landing_screen_nearby_title: "Рядом",
  landing_screen_nearby_subtitle: "Люди вокруг тебя прямо сейчас",
  landing_screen_nearby_count: "{count} человек",
  landing_screen_nearby_radius: "в радиусе {distance}",

  landing_screen_profile_name: "Ты, {age}",
  landing_screen_profile_tag_adventure: "Приключения",
  landing_screen_profile_tag_coffee: "Кофе",
  landing_screen_profile_tag_live_music: "Живая музыка",
  landing_screen_profile_ready: "Профиль готов",

  landing_screen_swipe_name: "{name}, {age}",
  landing_screen_swipe_distance: "в 1,2 км",
  landing_screen_swipe_tag_coffee: "Кофе",
  landing_screen_swipe_tag_live_music: "Живая музыка",
  landing_screen_swipe_tag_art: "Искусство",

  landing_screen_meet_title: "Выбери место встречи",
  landing_screen_meet_subtitle: "Популярные места рядом",
  landing_screen_meet_suggest: "Предложить место",
  landing_screen_spot_coffee_name: "Blue Bottle Coffee",
  landing_screen_spot_coffee_meta: "Кофе · 0,8 км",
  landing_screen_spot_bar_name: "The Rooftop Bar",
  landing_screen_spot_bar_meta: "Напитки · 1,4 км",
  landing_screen_spot_park_name: "Riverside Park",
  landing_screen_spot_park_meta: "На улице · 2,1 км",

  landing_screen_match_title: "Это Linq!",
  landing_screen_match_pair: "Ты и {name}",
  landing_screen_match_met_irl: "Вы познакомились вживую ✨",

  landing_screen_chat_contact_shared: "Контакт передан",
  landing_screen_chat_msg_1: "Привет! Было так классно 👋",
  landing_screen_chat_msg_2: "Согласна! В то же время на след. неделе?",
  landing_screen_chat_msg_3: "Договорились 💫",
  landing_screen_chat_placeholder: "Сообщение…",

  landing_screen_events_title: "Сегодня рядом с тобой",
  landing_screen_events_subtitle: "События, которые нравятся твоим мэтчам",
  landing_screen_event_location: "Центр · 1,1 км",
  landing_screen_event_rooftop_name: "Rooftop Social",
  landing_screen_event_rooftop_meta: "Сб · 21:00",
  landing_screen_event_rooftop_tag: "Иду",
  landing_screen_event_vinyl_name: "Vinyl & Wine",
  landing_screen_event_vinyl_meta: "Пт · 20:00",
  landing_screen_event_vinyl_tag: "+24 идут",

  landing_screen_checkin_title: "Rooftop Social",
  landing_screen_checkin_subtitle: "Ты на месте — отметься",
  landing_screen_checkin_scan: "Сканируй, чтобы связаться",
  landing_screen_checkin_button: "Чек-ин",
  landing_screen_checkin_points: "+50 CP",
  landing_screen_checkin_countdown: "Speed Linq начнётся через 5:00",

  landing_screen_leaderboard_title: "Топ тусовщиков",
  landing_screen_leaderboard_subtitle: "Rooftop Social · сегодня",
  landing_screen_leaderboard_you: "Ты",
  landing_screen_leaderboard_footer: "Ты на #2 — продолжай в том же духе!",

  // ---- Stats section ----
  landing_stats_title_prefix: "Меньше приложения. ",
  landing_stats_title_highlight: "Больше тебя.",
  landing_stats_subtitle:
    "Linqx создан, чтобы оторвать тебя от экрана и вернуть в момент.",
  landing_stats_small_talk_label: "Фраз пустого трёпа",
  landing_stats_irl_label: "Сначала встреча вживую",
  landing_stats_steps_suffix: " шага",
  landing_stats_steps_label: "От свайпа до реального плана",
  landing_stats_vibes_label: "Волн под твою энергию",

  // ---- CTA section ----
  landing_cta_title_prefix: "Там, где связи ",
  landing_cta_title_highlight: "оживают",
  landing_cta_subtitle:
    "Сделай мэтч с кем-то новым и разделите незабываемое впечатление вместе. От эксклюзивных событий до эпичных вечеров — превращай незнакомцев в истории.",
  landing_cta_pillar_swipe: "Свайп",
  landing_cta_pillar_link: "Связь",
  landing_cta_pillar_live: "Живи",
  landing_cta_button: "В список ожидания",

  // ---- Waitlist form ----
  landing_waitlist_badge: "Ограниченный ранний доступ",
  landing_waitlist_title_prefix: "Стань частью чего-то ",
  landing_waitlist_title_highlight: "особенного",
  landing_waitlist_subtitle: "Мэтч. Впечатления. Связь.",
  landing_waitlist_name_placeholder: "Твоё имя (необязательно)",
  landing_waitlist_email_placeholder: "Введи свой email",
  landing_waitlist_submit: "В список ожидания",
  landing_waitlist_disclaimer: "Без спама. Напишем только когда запустимся.",
  landing_waitlist_success_title: "Ты в списке!",
  landing_waitlist_success_subtitle: "Добро пожаловать в список ожидания",
  landing_waitlist_success_note: "Напишем тебе, когда запустимся.",
  landing_waitlist_error_email_required: "Введи свой адрес email",
  landing_waitlist_error_email_invalid: "Введи корректный адрес email",
  landing_waitlist_error_generic: "Что-то пошло не так. Попробуй ещё раз.",

  // ---- Footer ----
  landing_footer_tagline:
    "Без пустых разговоров. Только настоящие связи через общие впечатления.",
  landing_footer_rights: "© {year} Linqx. Все права защищены.",
  landing_footer_col_company: "Компания",
  landing_footer_col_legal: "Правовое",
  landing_footer_col_get_app: "Скачать приложение",
  landing_footer_link_about: "О нас",
  landing_footer_link_features: "Возможности",
  landing_footer_link_contact: "Контакты",
  landing_footer_link_privacy: "Политика конфиденциальности",
  landing_footer_link_terms: "Условия использования",
  landing_footer_link_eula: "EULA",
  landing_footer_social_x: "X",
  landing_footer_social_instagram: "Instagram",
  landing_footer_social_tiktok: "TikTok",
  landing_footer_social_email: "Email",
  landing_footer_coming_soon: "Скоро в",
  landing_footer_app_store: "App Store",
  landing_footer_google_play: "Google Play",

  // ---- Legal layout chrome ----
  landing_legal_back_home: "На главную",
  landing_legal_last_updated: "Обновлено: {date}",
  landing_legal_privacy_title: "Политика конфиденциальности",
  landing_legal_terms_title: "Условия использования",
  landing_legal_eula_title: "Лицензионное соглашение (EULA) Linqx",
  landing_legal_privacy_updated: "1 февраля 2025 г.",
  landing_legal_terms_updated: "6 февраля 2025 г.",
  landing_legal_eula_updated: "4 марта 2025 г.",
};
